const defineVaDataTableColumns = (columns) => columns;
const defineVaDataTableItems = (items) => items;
export {
  defineVaDataTableItems as a,
  defineVaDataTableColumns as d
};
//# sourceMappingURL=fabrics.js.map
